import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InnButton from "@/components/ds/button/Button.vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { computed, PropType } from "vue";
import { Document } from "@/types";
import { documentToPrefix, documentToSlug } from "@/tools/document";
import api from "@/api";
import { useDocumentsStore } from "@/stores/documents";
import { useUiStore } from "@/stores/ui";
import { useRouter } from "vue-router";
import { useProjectStore } from "@/stores/projects";
import { projectToSlug } from "@/tools/projects";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentDelete',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const documentsStore = useDocumentsStore();
const projectsStore = useProjectStore();
const uiStore = useUiStore();
const router = useRouter();

const prefix = computed(() => documentToPrefix(props.document));

const slug = computed(() => documentToSlug(props.document));

const goBackToProject = () => {
    const project = projectsStore.getItemById(props.document.projectId);
    if (project) {
        const slug = projectToSlug(project, -1);
        router.push({
            name: "Project",
            params: { slug: slug },
        });
    }
};

const deleteDocument = () => {
    if (props.document) {
        api.delete(props.document, "documents").then(() => {
            documentsStore.delete(props.document);
            goBackToProject();
            uiStore.message(prefix.value + " verwijderd...");
        });
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, { "max-width": "500" }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(IconButton, _mergeProps(activatorProps, {
        "icon-id": "trash",
        variant: "danger"
      }), {
        default: _withCtx(() => [
          _createTextVNode(" Verwijder " + _toDisplayString(prefix.value), 1)
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(({ isActive }) => [
      _createVNode(_component_v_card, { style: {"padding":"12px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(" Wil je " + _toDisplayString(prefix.value) + " " + _toDisplayString(slug.value) + " verwijderen? ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(InnButton, {
                onClick: 
                            () => {
                                isActive.value = false;
                                deleteDocument();
                            }
                        
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Verwijderen ")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}
}

})